import { render, staticRenderFns } from "./RequiresPrimaryConsultationModal.vue?vue&type=template&id=19c00718&"
import script from "./RequiresPrimaryConsultationModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RequiresPrimaryConsultationModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c00718')) {
      api.createRecord('19c00718', component.options)
    } else {
      api.reload('19c00718', component.options)
    }
    module.hot.accept("./RequiresPrimaryConsultationModal.vue?vue&type=template&id=19c00718&", function () {
      api.rerender('19c00718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InvasiveServiceInfo/components/RequiresPrimaryConsultationModal.vue"
export default component.exports